var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#05548E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.4,45.4C40.4,53.5,46.9,60,55,60s14.6-6.5,14.6-14.6c0-4-1.6-7.6-4.2-10.2l0,0l-0.1-0.1c0,0,0,0,0,0 L57,26.8h0c-0.5-0.5-1.2-0.8-2-0.8c-0.8,0-1.5,0.3-2,0.8h0l-7.8,7.8C42.3,37.3,40.4,41.1,40.4,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55,57.8c6.9,0,12.4-5.6,12.4-12.4C67.4,38.5,61.9,33,55,33s-12.4,5.6-12.4,12.4C42.6,52.3,48.1,57.8,55,57.8z  M55,33.7c6.4,0,11.7,5.2,11.7,11.7c0,6.4-5.2,11.7-11.7,11.7s-11.7-5.2-11.7-11.7C43.3,39,48.6,33.7,55,33.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 55,
    cy: 45.4,
    r: 8.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 55,
    cy: 45.4,
    r: 4.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDefault);
export default __webpack_public_path__ + "static/media/token-default.78e46b675ad4f77dbc0d08b7140c4e28.svg";
export { ForwardRef as ReactComponent };